// ─── Altesse Theme JS ───

document.addEventListener('DOMContentLoaded', () => {

  // ── Scroll-triggered reveals ──
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        const delay = entry.target.dataset.delay || 0;
        setTimeout(() => entry.target.classList.add('visible'), delay * 1000);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '-5% 0px' });
  reveals.forEach(el => observer.observe(el));

  // ── Header scroll ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 48);
    }, { passive: true });
  }

  // ── Mobile menu ──
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu__close');
  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
  }

  // ── Cart drawer ──
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('[data-close-cart]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Add to cart buttons on product cards ──
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('added');
    btn.textContent = '✓ Agregado a selección';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        updateCartCount();
        setTimeout(openCart, 300);
      }
    } catch (err) {
      console.error('Add to cart error:', err);
    }

    setTimeout(() => {
      btn.classList.remove('added');
      btn.textContent = '+ Agregar a selección';
    }, 2000);
  });

  // ── Cart quantity changes ──
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const lineIndex = btn.dataset.lineIndex;
    const delta = parseInt(btn.dataset.delta);
    const qtyEl = btn.parentElement.querySelector('[data-qty-value]');
    const currentQty = parseInt(qtyEl?.textContent || '1');
    const newQty = Math.max(0, currentQty + delta);

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineIndex, quantity: newQty })
      });
      if (res.ok) {
        const cart = await res.json();
        updateCartUI(cart);
      }
    } catch (err) { console.error(err); }
  });

  // ── Update cart count badge ──
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count > 9 ? '9+' : cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (err) {}
  }

  async function updateCartUI(cart) {
    updateCartCount();
    const itemsEl = document.querySelector('.cart-drawer__items');
    const subtotalEl = document.querySelector('.cart-drawer__subtotal strong');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="font-family:Jost,sans-serif;font-size:0.82rem;font-weight:300;color:#8C8478;text-align:center;padding:40px 0;">Tu carrito está vacío</p>';
    } else {
      itemsEl.innerHTML = cart.items.map((item, i) => `
        <div class="cart-item">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}">
          <div class="cart-item__info">
            <p class="cart-item__name">${item.product_title}</p>
            ${item.variant_title ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
            <p class="cart-item__price">${formatMoney(item.line_price)}</p>
            <div class="cart-item__qty">
              <button data-qty-change data-line-index="${i+1}" data-delta="-1">−</button>
              <span data-qty-value>${item.quantity}</span>
              <button data-qty-change data-line-index="${i+1}" data-delta="1">+</button>
            </div>
          </div>
        </div>
      `).join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function formatMoney(cents) {
    return 'S/ ' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // Init cart count
  updateCartCount();

  // ── Filter tabs (collection page) ──
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.filter-tab');
    if (!tab) return;
    document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
  });

  // ── Product gallery thumbs ──
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const main = document.querySelector('.product-gallery__main img');
    const src = thumb.querySelector('img')?.src;
    if (main && src) {
      main.src = src;
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    }
  });

  // ── Custom jewelry form chips ──
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.chip');
    if (!chip || !chip.closest('.chip-group-single')) return;
    const group = chip.closest('.chip-group-single');
    group.querySelectorAll('.chip').forEach(c => c.classList.remove('selected'));
    chip.classList.add('selected');
    const input = group.nextElementSibling;
    if (input && input.type === 'hidden') input.value = chip.textContent.trim();
  });

  // Handle multi-select chips
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.chip');
    if (!chip || chip.closest('.chip-group-single')) return;
    chip.classList.toggle('selected');
  });

});
